import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71acc9d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71acc9d4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acc9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71acc9d4')) {
      api.createRecord('71acc9d4', component.options)
    } else {
      api.reload('71acc9d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71acc9d4&scoped=true", function () {
      api.rerender('71acc9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technology/FaceRecognition/index.vue"
export default component.exports